import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Comment\Comment\DeleteCommentController::__invoke
* @see app/Http/Controllers/Comment/Comment/DeleteCommentController.php
* @route '/api/comment/{comment}'
*/
const DeleteCommentController = (args: { comment: string | number | { id: string | number } } | [comment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteCommentController.url(args, options),
    method: 'delete',
})

DeleteCommentController.definition = {
    methods: ["delete"],
    url: '/api/comment/{comment}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Comment\Comment\DeleteCommentController::__invoke
* @see app/Http/Controllers/Comment/Comment/DeleteCommentController.php
* @route '/api/comment/{comment}'
*/
DeleteCommentController.url = (args: { comment: string | number | { id: string | number } } | [comment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { comment: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { comment: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            comment: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        comment: typeof args.comment === 'object'
        ? args.comment.id
        : args.comment,
    }

    return DeleteCommentController.definition.url
            .replace('{comment}', parsedArgs.comment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Comment\Comment\DeleteCommentController::__invoke
* @see app/Http/Controllers/Comment/Comment/DeleteCommentController.php
* @route '/api/comment/{comment}'
*/
DeleteCommentController.delete = (args: { comment: string | number | { id: string | number } } | [comment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteCommentController.url(args, options),
    method: 'delete',
})

export default DeleteCommentController